const APP_PRODUCER_CONTRACT = { name: 'main_contract', version: '1', owner_type: 'application' };
const APP_NAME = 'sub-auth-webapp';
const APP_VERSION =
  (typeof window !== 'undefined' &&
    window.__app__ &&
    window.__app__.application &&
    window.__app__.application.version) ||
  '1.0.0';

let initialized = false;

function isBrowser() {
  return typeof window !== 'undefined';
}

function isNhstReady() {
  return isBrowser() && Boolean(window.NhstTracking);
}

function topWindow() {
  if (typeof window === 'undefined') return null;
  try {
    return window.top && window.top.__nhstTrackingReady ? window.top : window;
  } catch (e) {
    return window;
  }
}

// system_action events are suppressed in external (embedded) views.
function shouldSkipEvent(payload) {
  return (
    window.$store.state.isExternalView &&
    payload &&
    payload.event &&
    payload.event === 'system_action'
  );
}

export function initializeNhstTracking() {
  if (!isBrowser()) return;
  if (initialized) return;
  if (!isNhstReady()) {
    // eslint-disable-next-line no-console
    console.warn('[NhstTracking] window.NhstTracking not defined; tracking disabled');
    return;
  }
  try {
    const win = topWindow();
    win.NhstTracking.initializeTracking({
      applicationName: APP_NAME,
      applicationVersion: APP_VERSION,
      ownerType: 'application',
      producerContract: { ...APP_PRODUCER_CONTRACT },
    });
    initialized = true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[NhstTracking] initializeTracking failed', e);
  }
}

/**
 * Push a NhstTracking event. Caller owns the full payload shape
 * (event, sub_producer_contract, attributes).
 */
export function addTrackingEvent(payload) {
  if (!isNhstReady() || shouldSkipEvent(payload)) return;
  const trackingData = {
    ...payload,
    sub_application_name: APP_NAME,
    sub_application_version: APP_VERSION
  };
  const win = topWindow();
  try {
    win.NhstTracking.track(trackingData);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[NhstTracking] track failed', e, trackingData);
  }
}

/**
 * Emit a page_view. Used for both the initial load and SPA route changes —
 * the NhstTracking library differentiates them via its own context IDs
 * (instance_app_load_id resets on full reload, instance_page_load_id resets
 * on SPA navigation), so the same call is correct in both cases.
 */
export function trackPageView(page = {}) {
  if (!isNhstReady() || shouldSkipEvent(page)) return;
  try {
    const win = topWindow();
    win.NhstTracking.trackPageLoad({
      page,
      sub_application_name: APP_NAME,
      sub_application_version: APP_VERSION
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[NhstTracking] trackPageLoad failed', e);
  }
}
